module.exports = __webpack_public_path__ + "img/heart_full.f2c22601.svg";